import { Injectable } from '@angular/core';
import { CategoriesMenuNode, OccMenuParams } from '@main/categories-menu/const';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { CategoriesMenuActions } from '../store/actions';
import { CategoriesMenuData, StateWithCategoriesMenu } from '../store/categories-menu-state';
import { CategoriesMenuSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CategoriesMenuService {
  isOpen$: Observable<boolean> = this.store.pipe(
    select(CategoriesMenuSelectors.getCategoriesMenuValue),
    map((data: CategoriesMenuData) => data.isOpen),
    distinctUntilChanged(),
  );

  constructor(private store: Store<StateWithCategoriesMenu>) {}

  toggleOpen = (isOpen?: boolean): void => {
    this.store.dispatch(new CategoriesMenuActions.CategoriesMenuToggleOpen(isOpen));
  };

  load({ nodeId, level }: OccMenuParams): void {
    this.store.dispatch(new CategoriesMenuActions.CategoriesMenuLoad({ nodeId, level }));
  }

  getNode({ nodeId, level }: OccMenuParams): Observable<CategoriesMenuNode | undefined> {
    return this.store.pipe(
      select(CategoriesMenuSelectors.getCategoriesMenuNode(nodeId)),
      tap((node: CategoriesMenuNode) => {
        if (!node || !node.depth || node.depth < level) {
          this.load({ nodeId, level });
        }
      }),
      catchError(() => {
        /**
         * Если селектор getCategoriesMenuNode выдал ошибку, что еще нет в сторе catalog.categoriesMenu все равно получаем меню
         * Ошибки ответа бэкенда обрабатываются в эффекте CategoriesMenuEffects.loadCategoriesMenu$
         */
        this.load({ nodeId, level });

        return of(undefined);
      }),
    );
  }

  getAllData(): Observable<CategoriesMenuData> {
    return this.store.pipe(select(CategoriesMenuSelectors.getCategoriesMenuValue));
  }

  getLoading = (): Observable<boolean> => {
    return this.store.pipe(select(CategoriesMenuSelectors.getCategoriesMenuLoading));
  };

  getSuccess = (): Observable<boolean> => {
    return this.store.pipe(select(CategoriesMenuSelectors.getCategoriesMenuSuccess));
  };

  getError = (): Observable<boolean> => {
    return this.store.pipe(select(CategoriesMenuSelectors.getCategoriesMenuError));
  };
}
